import { uuid } from './../../util/index'

export default {
    document_db_id: null,
    document_url_id: null,
    entity_id: null,
    name: 'Title this Data Model Planner...',
    description: 'Add a compelling description of the data model',
    entity_name: 'Model Planner',
    entity_group: 'Model Planner',
    section1: {
        name: "Lookup Tables",
        tasks: []
    },
    section2: {
        name: "Measure Groups",
        tasks: []
    },
    section3: {
        name: "Fact Tables",
        tasks: []
    },
    section4: {
        name: "Supporting Tables",
        tasks: []
    },
    team_id: null,
    team_shared: false,
}
